import { spacer32 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { List } from "../List";
var TypeListComponent = styled(List).attrs({
  listStyleReset: false
}).withConfig({
  displayName: "TypeList__TypeListComponent",
  componentId: "sc-1mv2mac-0"
})(["padding-left:", ";padding-bottom:", ";"], spacer32, function (props) {
  return props.condensed && '0';
});
var typeListHelpers = {
  ul: TypeListComponent.withComponent('ul'),
  ol: TypeListComponent.withComponent('ol')
};
export var TypeList = Object.assign(TypeListComponent, typeListHelpers);
export default TypeList;